import React from 'react';
import PropTypes from 'prop-types';
import './ScreenReaderOnly.scss';

const ScreenReaderOnly = ({
  children,
  id,
  tabIndex = 0,
  role,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedby,
  className = '',
  ...props
}) => {
  return (
    <div
      id={id}
      className={`sr-only-component ${className}`}
      tabIndex={tabIndex}
      role={role}
      aria-label={ariaLabel}
      aria-describedby={ariaDescribedby}
      {...props}
    >
      {children}
    </div>
  );
};

ScreenReaderOnly.propTypes = {
  children: PropTypes.node,
  id: PropTypes.string,
  tabIndex: PropTypes.number,
  role: PropTypes.string,
  'aria-label': PropTypes.string,
  'aria-describedby': PropTypes.string,
  className: PropTypes.string,
};

export default ScreenReaderOnly;
